import { render } from "./BgImg.vue?vue&type=template&id=0c9127fb"
import script from "./BgImg.vue?vue&type=script&lang=js"
export * from "./BgImg.vue?vue&type=script&lang=js"

import "./BgImg.vue?vue&type=style&index=0&id=0c9127fb&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__